/* The one place nox-widget.js gets loaded from. Rendered by the header group's
   Nox section (sections/nox.liquid), whose settings arrive as data attributes:

   data-nox-key       the site key; without it the widget never mounts
   data-nox-launcher  'true' shows the widget's floating "Start your journey"
                      button on every page except product pages
   data-nox-page      the Shopify page type; on 'product' the button never
                      shows, so nothing sits over the add to cart bar

   ?nox_preview=<the section's preview code> shows the button (except on
   product pages) and the product page banner, via the html.nox-preview class
   the section sets, for the rest of the browser session. ?nox_preview=0
   turns it back off. Not ?nox=, which the widget reads as its site key.

   With the button off the widget is only fetched when someone asks for Nox:
   a [data-nox-open] click or window.noxOpen(trigger). It mounts its iframe the
   moment it loads, so preloading would call nox.arched.dev for every visitor.
   The widget has no switch for its button, but it hides it while a .nox-hero
   element is on screen, so a pinned invisible one keeps it hidden. */
(function () {
  'use strict';

  var loader = document.currentScript;
  if (!loader) return;
  var widgetLoad;
  var pending;

  var launcher = loader.dataset.noxPage !== 'product' &&
    (loader.dataset.noxLauncher === 'true' || document.documentElement.classList.contains('nox-preview'));

  function loadWidget() {
    if (document.getElementById('nox-widget')) return Promise.resolve();
    if (widgetLoad) return widgetLoad;
    widgetLoad = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = 'https://nox.arched.dev/nox-widget.js';
      script.async = true;
      script.referrerPolicy = 'no-referrer';
      if (loader.dataset.noxKey) script.dataset.noxKey = loader.dataset.noxKey;
      script.onload = resolve;
      script.onerror = function () {
        script.remove();
        widgetLoad = null;
        reject(new Error('Nox could not load'));
      };
      document.body.appendChild(script);
    });
    return widgetLoad;
  }

  /* fixed to the viewport from <body>, not the header group: the sticky header
     translates, which would carry a fixed child off screen with it */
  function hideLauncher() {
    var sentinel = document.createElement('div');
    sentinel.className = 'nox-hero';
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;visibility:hidden;pointer-events:none;';
    document.body.appendChild(sentinel);
  }

  function openNox(trigger) {
    if (pending) return;
    var dialog = document.createElement('dialog');
    dialog.className = 'nox-hero-loading';
    dialog.setAttribute('aria-label', 'Nox');
    var style = document.createElement('style');
    style.textContent = '.nox-hero-loading{position:fixed;inset:0;box-sizing:border-box;width:100%;max-width:none;height:100%;max-height:none;margin:0;padding:24px;border:0;background:#f3f5f7;color:#111827;font:16px/1.5 system-ui,sans-serif;text-align:center}.nox-hero-loading[open]{display:flex;align-items:center;justify-content:center}.nox-hero-loading button{position:absolute;top:16px;right:16px;width:44px;height:44px;padding:0;border:1px solid #d9dee7;border-radius:50%;background:#fff;color:#111827;font:24px/1 system-ui,sans-serif;cursor:pointer}.nox-hero-loading button:focus-visible{outline:3px solid #8b5cc4;outline-offset:3px}';
    var message = document.createElement('p');
    message.setAttribute('role', 'status');
    message.textContent = loader.dataset.noxLoading;
    var close = document.createElement('button');
    close.type = 'button';
    close.textContent = '×';
    close.setAttribute('aria-label', loader.dataset.noxClose);
    dialog.append(style, message, close);
    document.body.appendChild(dialog);
    var previousOverflow = document.body.style.overflow;
    var timer;
    var observer;
    var finished = false;
    pending = dialog;

    function stopWaiting() {
      clearTimeout(timer);
      if (observer) observer.disconnect();
    }

    function dismiss(restoreFocus) {
      if (finished) return;
      finished = true;
      stopWaiting();
      pending = null;
      dialog.close();
      dialog.remove();
      document.body.style.overflow = previousOverflow;
      if (restoreFocus && trigger && trigger.isConnected) trigger.focus();
    }

    function unavailable() {
      if (finished) return;
      stopWaiting();
      message.textContent = loader.dataset.noxUnavailable;
    }

    function openWhenReady() {
      if (finished) return;
      if (!document.getElementById('nox-widget')) {
        unavailable();
      } else if (document.documentElement.getAttribute('data-nox-widget') === 'ready') {
        dismiss(false);
        window.dispatchEvent(new Event('nox:open'));
      }
    }

    close.addEventListener('click', function () { dismiss(true); });
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      dismiss(true);
    });
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    timer = setTimeout(unavailable, 20000);
    loadWidget().then(function () {
      if (finished) return;
      observer = new MutationObserver(openWhenReady);
      observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-nox-widget'] });
      observer.observe(document.body, { childList: true });
      openWhenReady();
    }).catch(unavailable);
  }

  window.noxOpen = openNox;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-nox-open]');
    if (!trigger) return;
    event.preventDefault();
    openNox(trigger);
  });

  if (!launcher) {
    hideLauncher();
    return;
  }
  function preload() { loadWidget().catch(function () {}); }
  if (document.readyState === 'complete') preload();
  else window.addEventListener('load', preload, { once: true });
})();
